export default {
  lasso: {
    displayOrder: 10000,
  },
  rangeDim: {
    displayOrder: 10000,
  },
  rangeMeasure: {
    displayOrder: 10000,
  },
  rangeMinor: {
    displayOrder: 10000,
  },

  // SPARK
  scrollBar: {
    minimumLayoutMode: 'SPARK',
    prioOrder: -1,
    displayOrder: 100,
  },

  refLines: {
    layout: {
      minimumLayoutMode: 'SPARK',
      prioOrder: 60,
      displayOrder: 1110,
    },
  },

  // XMALL
  measureAxisTitle: {
    minimumLayoutMode: 'XSMALL',
    prioOrder: 30,
    displayOrder: 90,
  },
  dimensionAxisTitle: {
    minimumLayoutMode: 'XSMALL',
    prioOrder: 30,
    displayOrder: 90,
  },

  measureAxis: {
    minimumLayoutMode: 'XSMALL',
    prioOrder: 10,
    displayOrder: 80,
  },
  dimensionAxis: {
    minimumLayoutMode: 'XSMALL',
    prioOrder: 10,
    displayOrder: 80,
  },

  gridLines: {
    minimumLayoutMode: 'XSMALL',
    displayOrder: -100,
  },

  // SMALL
  refLinesLabels: {
    minimumLayoutMode: 'SMALL',
    prioOrder: 60,
    displayOrder: 0,
  },
};
